import { Bars3Icon } from '@heroicons/react/24/outline'
import { useRouter } from 'next/router'
import { FC } from 'react'

import { useUser } from '@/api/models/common'
import { useSelectedProject } from '@/api/models/main/hooks/useSelectedProject'
import { ScreenSize } from '@/app/constants'
import { YandexMetrikaEvent } from '@/app/constants/metrics'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'
import AppLogoSvg from '@/assets/svg/AppLogo.svg'
import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'
import UserProfile from '@/components/entities/user/ui/UserProfile'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'

import { Notifications } from './Notifications'
import { ProjectSelectionButton } from './ProjectSelectionButton'

type Props = {
  className?: string
  isSidebarExpanded: boolean
  expandSidebar: () => void
}

const AppHeader: FC<Props> = ({
  className,
  isSidebarExpanded,
  expandSidebar
}) => {
  const { isLoading } = useUser()

  const { breakpoint } = useCurrentBreakpoint()

  const isMobileScreen = [
    ScreenSize.Xxs,
    ScreenSize.Xs,
    ScreenSize.Sm
  ].includes(breakpoint)

  const router = useRouter()

  const { setModalOpened } = useSelectedProjectStore()
  const { selectedProject } = useSelectedProject()
  const { reachGoal } = useYandexMetrika()

  const handleProjectSelectClick = () => {
    setModalOpened(true)
    reachGoal(YandexMetrikaEvent.MAIN_PROJECT_СHANGE)
  }

  return (
    <header
      className={cn(
        `fixed right-0 z-40 flex h-80 border-b border-grey-30 bg-grey-10 px-30 py-18`,
        'xs:flex xs:h-62 xs:items-center xs:border-b-0 xs:bg-grey-100 xs:px-16 xs:py-15',
        className
      )}
    >
      {selectedProject && (
        <ProjectSelectionButton
          isLoading={isLoading}
          selectedProjectName={selectedProject.bc_name}
          handleProjectSelectClick={handleProjectSelectClick}
        />
      )}
      <div className="hidden space-x-16 xs:flex">
        <button
          aria-label="Раскрыть меню"
          className="relative h-28 w-28 text-white"
          onClick={expandSidebar}
        >
          <Bars3Icon className={cn('absolute inset-0 h-full w-full')} />
        </button>

        <button
          aria-label="Перейти на главную"
          title="На главную"
          onClick={() => router.push('/')}
        >
          <AppLogoSvg className="text-white" />
        </button>
      </div>

      {!(isSidebarExpanded && isMobileScreen) && (
        <div className="ml-auto flex space-x-15">
          <Notifications />
          <UserProfile isLoading={isLoading} />
        </div>
      )}
    </header>
  )
}

export { AppHeader }
